// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "08b64024c6a5d7b14671fc6dab121a9a409afff8/static/css/" + chunkId + "." + {"200":"4f7b3521","825":"f81e5cfb","864":"f2764e67"}[chunkId] + ".chunk.css";
};